import { NgModule, Injectable } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// import { AdminComponent } from './Layouts/admin/admin.component';

// import { LoginComponent } from './Pages/login/login.component';
import { NotFoundComponent } from './Pages/404/notfound.component';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HTTP_INTERCEPTORS, HttpClientModule, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { StorageService } from './Services/storage.service';
// import { DocumentationComponent } from './Pages/documentation/documentation.component';
import { MasterRouting } from './Pages/master/master.routing';
// import { DashboardComponent } from './Pages/dashboard/dashboard.component';
import { HomepageComponent } from './Pages/homepage/homepage.component';
import { OrganizationRouting } from './Pages/organization/organization.routing';
import { AuthenticationComponent } from './authentication/authentication.component';

import { ServiceDeclaration } from './Services/service.declaration';
import { ApiTokenInterceptor } from './Services/apiTokenInterceptor.service';
import { CustomPipes, ProviderPipes } from './pipe/pipe.declaration';
import { RosteringPageDeclaration } from './Directives/roastering/roastering.declaration';
import { PagesDeclaration } from './Pages/pages.declaration';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DirectiveDeclaration } from './Directives/directives.module';
import { CustomMaterialModule } from './material.module';
import { storeDeclaration } from './store/store.declaration';
import { ProfileState } from './State/profile.state';
import { PrivacyPolicyComponent } from './Pages/policies/privacy-policy';
import{PoliciesPageComponent} from './Pages/policies-page/policies-page';
import { LayoutsDeclaration } from './Layouts/layouts.declaration';
import { ProvidersDeclaration } from './providers/providers.declarations';
import { DemoChatBotComponent } from './Pages/demo-chat-bot/demo-chat-bot.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { PoliciesComponent } from './Pages/policies-add/policies.component';



const routes: Routes = [
  { path: '', redirectTo: '/homepage', pathMatch: 'full' },
  // { path: 'homepage', loadChildren: () => import('./Pages/homepage/homepage.module').then(m => m.HomepageModule) },
  { path: 'homepage', component: HomepageComponent },
  { path: 'chat-bot', component: DemoChatBotComponent },
  { path: 'organization/transport-manager/reset-password/:param', component: AuthenticationComponent },
  // { path: 'docs', component: DocumentationComponent },
  {
    // path: '', component: AdminComponent,
    path: '',
    children: [
      { path: 'organization', children: OrganizationRouting },
      { path: 'master', children: MasterRouting },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
    ]
  },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  // { path: 'privacy-policies', component: PoliciesPageComponent },
  { path: 'privacy-policies', component: PoliciesComponent },

  { path: '404', component: NotFoundComponent },
  { path: '**', redirectTo: '/404' }

];


@NgModule({
  declarations: [
    CustomPipes,
    RosteringPageDeclaration,
    LayoutsDeclaration,
    PagesDeclaration,
    DirectiveDeclaration,
    ProvidersDeclaration,
    PrivacyPolicyComponent,
    PoliciesComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    CustomMaterialModule,
    RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy', enableTracing: false }),
    HttpClientModule,
    DragDropModule
  ],
  exports: [RouterModule],
  providers: [
    ServiceDeclaration, storeDeclaration, ProfileState,
    { provide: HTTP_INTERCEPTORS, useClass: ApiTokenInterceptor, multi: true },ProviderPipes
  ]
})
export class AppRoutingModule { }
